import { render } from "./queryMapping.vue?vue&type=template&id=1b2dc258&scoped=true"
import script from "./queryMap.js?vue&type=script&lang=js"
export * from "./queryMap.js?vue&type=script&lang=js"

import "./queryMapping.vue?vue&type=style&index=0&id=1b2dc258&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2dc258"]])

export default __exports__